import { IconModel } from './icon.model';
import { LocalizedValueModel } from './localized-value.model';
import {
  DataEntryPresenterModel,
  StatisticQueryPresenterModel,
} from './presenter-models';
import { RefProperty } from './ref-property.model';

/** Data Models **/
export interface DashboardElement {
  id: string;
  /**
   * The type of the dashboard content fixed in this interface
   */
  elementType: DashboardElementType;
  /**
   * A reference property for the element with the structure for StatisticQuery
   * {dataEntity: 'StatisticQuery', dataEntry: 'uuid-for-statistic-query'}
   * */
  element: RefProperty;
  /**
   * The block which the element belongs to. Undefined if the element doesn't belong to a block
   */
  group?: string;
  /**
   * The index of the element in the dashboard
   */
  index: number;
}

export interface DashboardGroup {
  id: string;
  /**
   * The type of the dashboard content fixed to Dashboard Group
   */
  elementType: DashboardElementType;
  /**
   * The name of the block
   */
  name: LocalizedValueModel;
  /**
   * The description for the block
   */
  description?: LocalizedValueModel;
  /**
   * The icon of the block.
   */
  icon?: IconModel;
  /**
   * The index of the block in the dashboard
   */
  index: number;
}

/** Presenter models **/
export interface DashboardEntryValuePresenterModel {
  id: string;
  name: LocalizedValueModel;
  elements: (DashboardElementPresenterModel | DashboardGroupPresenterModel)[];
  relatedTo?: RefProperty;
  _elements?: StatisticQueryPresenterModel[];
}

export interface DashboardGroupPresenterModel {
  id: string;
  elementType: DashboardElementType;
  name: LocalizedValueModel;
  description?: LocalizedValueModel;
  icon?: IconModel;
  index: number;
  elements: (DashboardElementPresenterModel & DashboardGroupPresenterModel)[];
}

export class DashboardElementPresenterModel {
  id: string;
  elementType: DashboardElementType;
  element: RefProperty;
  group?: string;
  index: number;
}

export class DashboardEntryPresenterModel extends DataEntryPresenterModel {
  override dataEntity: 'DASHBOARD';
  override value: DashboardEntryValuePresenterModel;
}

export enum DashboardScope {
  DataModule = 'DataModule',
  DataEntity = 'DataEntity',
  System = 'System',
}

export interface MoveToGroupModel {
  item: DashboardElementPresenterModel;
  prevGroupId: string;
  nextGrpupId: string;
}

export enum DashboardElementType {
  Element = 'Element',
  DashboardGroup = 'DashboardGroup',
}
